import { convertirAMonedaLocal } from "../exchangeRateService";

// src/utils/carteleria/convertirMontoCarteleria.js
//
// PUNTO ÚNICO de conversión de moneda de las pantallas de Cartelería (rediseño F3a). Hoy envuelve
// EXACTAMENTE lo que hacían las 3 pantallas (tabla, cabecera, dashboard) con el `convert` de
// `useCurrency` — mismo TC vivo, sin cambios. Es el lugar donde después se aplica el Criterio 1
// (`2026-10-04-reingenieria-ebitda-decision-criterio-tc.md`): TC de la fecha del documento; sin fecha
// propia, TC promedio del mes. Cambiar el criterio = tocar SOLO este archivo.
//
// Contrato (idéntico al `toLocal` de la cabecera y al `moneda ? convert(...) : total` de la tabla):
//   - monto vacío/0 → 0
//   - sin moneda de origen → se asume la de destino (no se convierte)
//   - origen == destino → el monto tal cual (no se llama al conversor)
//   - si no → convert(monto, origen, destino)
//
// @param {Function} convert el `convert(amount, from, to)` de `useCurrency()`
export const convertirMontoCarteleria = (convert, monto, desde, hacia) => {
  if (!monto) return 0;
  const origen = desde || hacia;
  return origen !== hacia ? convert(monto, origen, hacia) : monto;
};

// Variante POR FECHA DEL DOCUMENTO (Criterio 1: TC de la fecha del documento; sin fecha propia, la del mes) para
// las superficies de resultado y ventas (`calculateVentas`, `calcularCierresFacturacion`, Proyección): hoy
// delega TAL CUAL en `convertirAMonedaLocal` de `exchangeRateService` (mismo TC, mismo redondeo), pero es el
// ÚNICO punto por donde pasa la conversión de Cartelería en esas superficies.
export const convertirMontoCarteleriaPorFecha = (monto, moneda, pais, fecha) =>
  convertirAMonedaLocal(monto, moneda, pais, fecha);
